/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { personFragment } from '../../../apollo/fragments/personFragment.gql';
import { CreditAppSavedSectionInfo } from '../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePeopleInfoData_updateCreditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson_address_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly city: string | null, readonly state: string | null, readonly street: string | null, readonly streetAdditional: string | null, readonly postalCode: string | null, readonly countryCode: string | null };

export type UpdatePeopleInfoData_updateCreditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: UpdatePeopleInfoData_updateCreditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type UpdatePeopleInfoData_updateCreditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: UpdatePeopleInfoData_updateCreditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type UpdatePeopleInfoData_updateCreditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type UpdatePeopleInfoData_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type UpdatePeopleInfoData_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly hasOutsourcedAccountant: boolean | null, readonly beneficialOwners: ReadonlyArray<UpdatePeopleInfoData_updateCreditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly authorizedSigner: UpdatePeopleInfoData_updateCreditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly outsourcedAccountant: UpdatePeopleInfoData_updateCreditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null, readonly savedSectionsInfo: ReadonlyArray<UpdatePeopleInfoData_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type UpdatePeopleInfoData_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: UpdatePeopleInfoData_updateCreditApplication_CreditApplication };


export type UpdatePeopleInfoDataVariables = _Types.Exact<{
  beneficialOwners?: _Types.InputMaybe<ReadonlyArray<_Types.PersonInput> | _Types.PersonInput>;
  authorizedSigner?: _Types.InputMaybe<_Types.PersonInput>;
  outsourcedAccountant?: _Types.InputMaybe<_Types.PersonInput>;
  creditApplicationId: _Types.Scalars['ID']['input'];
  hasOutsourcedAccountant?: _Types.InputMaybe<_Types.Scalars['Boolean']['input']>;
}>;


export type UpdatePeopleInfoData = UpdatePeopleInfoData_Mutation;


export const UpdatePeopleInfoDataDocument = gql`
    mutation UpdatePeopleInfoData($beneficialOwners: [PersonInput!], $authorizedSigner: PersonInput, $outsourcedAccountant: PersonInput, $creditApplicationId: ID!, $hasOutsourcedAccountant: Boolean) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    authorizedSigner: $authorizedSigner
    beneficialOwners: $beneficialOwners
    outsourcedAccountant: $outsourcedAccountant
    hasOutsourcedAccountant: $hasOutsourcedAccountant
  ) {
    salesforceCreditId
    fetchedAt
    beneficialOwners {
      ...personFragment
    }
    authorizedSigner {
      ...personFragment
    }
    hasOutsourcedAccountant
    outsourcedAccountant {
      id
      email
      firstName
      lastName
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${personFragment}
${CreditAppSavedSectionInfo}`;
export type UpdatePeopleInfoDataMutationFn = Apollo.MutationFunction<UpdatePeopleInfoData, UpdatePeopleInfoDataVariables>;

/**
 * __useUpdatePeopleInfoData__
 *
 * To run a mutation, you first call `useUpdatePeopleInfoData` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeopleInfoData` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeopleInfoData, { data, loading, error }] = useUpdatePeopleInfoData({
 *   variables: {
 *      beneficialOwners: // value for 'beneficialOwners'
 *      authorizedSigner: // value for 'authorizedSigner'
 *      outsourcedAccountant: // value for 'outsourcedAccountant'
 *      creditApplicationId: // value for 'creditApplicationId'
 *      hasOutsourcedAccountant: // value for 'hasOutsourcedAccountant'
 *   },
 * });
 */
export function useUpdatePeopleInfoData(baseOptions?: Apollo.MutationHookOptions<UpdatePeopleInfoData, UpdatePeopleInfoDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePeopleInfoData, UpdatePeopleInfoDataVariables>(UpdatePeopleInfoDataDocument, options);
      }
export type UpdatePeopleInfoDataHookResult = ReturnType<typeof useUpdatePeopleInfoData>;
export type UpdatePeopleInfoDataMutationResult = Apollo.MutationResult<UpdatePeopleInfoData>;
export type UpdatePeopleInfoDataMutationOptions = Apollo.BaseMutationOptions<UpdatePeopleInfoData, UpdatePeopleInfoDataVariables>;